var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-box"},[_c('img',{attrs:{"src":"https://resource.rcclchina.com.cn/cruiseDetail/pc/booking_pay/bookingIcon.png","alt":""}}),_c('span',[_vm._v("支持订金预订¥1000/人起")])])
}]

export { render, staticRenderFns }